export default __webpack_public_path__ + "static/media/google.027d83bd.svg";